import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class LayoutConfirmModalComponent {

  title: string;
  description: string;
  accept: string;
  reject: string;
  hasOkBtn: boolean = true;

  constructor(public modalRef: NgbModal) { }

  confirm() { } // external override
  onConfirm() {
    if (typeof this.confirm === 'function') {
      this.confirm();
    }
    this.modalRef.dismissAll();
  }

  decline() { } // external override
  onDecline() {
    if (typeof this.decline === 'function') {
      this.decline();
    }
    this.modalRef.dismissAll();
  }
}
